module.exports = __webpack_public_path__ + "static/media/place3Icon.16b30336.svg";